class Toast {

    defaultOptions(){
        return {
            'delay': 500,
            'autohide': true,
            'animation': true,
            'position': 'bottomRight',//bottomRight,bottomLeft,bottomCenter,topLeft,topCenter,topRight
            'onShow': function(event){ },
            'onHide': function(event){ },

            'toastClass': '',
            'headerContent': '',
            'bodyContent': '',

            'showHeader': true,
            'showBody': true,
        };
    }

    constructor(options){
        this.settings = $.extend(this.defaultOptions(),options);

        // initialize attributes
        //this.$example = $('.class',this.$container);

        // bind events methods
        //this.onEvent = this.onEvent.bind(this);
        this.onShow = this.onShow.bind(this);
        this.onHide = this.onHide.bind(this);
        this.onClick  = this.onClick.bind(this);

        // initalize object
        this.initialize();
    }

    getContainerId(){
        return "toastContainer"+this.settings.position;
    }

    getWrapper(){
        return $('#outofscope');
    }

    initialize(){

        var $container = $("#"+this.getContainerId(),this.getWrapper());
        if($container.length > 0){
            this.$container = $container;
        }else{
            this.$container = $('<div/>')
            .attr('id',this.getContainerId())
            .addClass('app-toast-container')
            .addClass('m-1');
            this.getWrapper().append(this.$container);

            switch(this.settings.position){
                case 'bottom':
                case 'bottomRight':
                case 'bottomLeft':
                case 'bottomCenter':
                    this.$container.addClass('fixed-bottom');
                break;

                case 'top':
                case 'topRight':
                case 'topLeft':
                case 'topCenter':
                    this.$container.addClass('fixed-top');
                break;
            }

        }


        this.$toast = $('<div/>')
        .attr('id',window.uniqid())
        .addClass('toast app-toast')
        .addClass(this.settings.toastClass)
        .attr('role','alert')
        .attr('aria-live',"assertive")
        .attr('aria-atomic',"true")
        .attr('data-animation',this.settings.animation ? 'true' : 'false')
        .appendTo(this.$container)
        .on('click',this.onClick);

        if(this.settings.autohide){
            this.$toast
            .attr('data-bs-delay',this.settings.delay)
            .data('bs-delay',this.settings.delay)
        }else{
            this.$toast
            .attr('data-bs-autohide',false)
            .data('bs-autohide',false)
        }

        switch(this.settings.position){
            case 'bottomLeft':
            case 'topLeft':
                this.$toast.addClass('mr-auto');

            case 'bottomRight':
            case 'topRight':
                this.$toast.addClass('ml-auto');
            break;

            case 'bottom':
            case 'bottomCenter':
            case 'top':
            case 'topCenter':
                this.$toast.addClass('m-auto');
            break;

        }

        this.$header = $('<div/>')
        .addClass('toast-header')
        .appendTo(this.$toast);

        if(!this.settings.showHeader){
            this.$header.hide();
        }



        this.$body = $('<div/>')
        .addClass('toast-body')
        .appendTo(this.$toast);

        if(!this.settings.showBody){
            this.$body.hide();
        }


        this
        .setHeaderContent(this.settings.headerContent)
        .setBodyContent(this.settings.bodyContent);

        //this.toast = this.toast({
        //  'delay' : this.settings.delay,
        //  'autohide' : this.settings.autohide ? true : false,
        //  'animation' : this.settings.animation ? true : false,
        //});


        this.$toast
        .on('shown.bs.toast',this.onShow)
        .on('hidden.bs.toast',this.onHide);

        this.toast = new bootstrap.Toast(this.$toast[0]);
    }

    setHeaderContent($element){
        this.$header
        .html('')
        .append($element)
        .append(
            $('<button/>')
            .attr('type','button')
            .attr('data-dismiss','toast')
            .attr('aria-label','Close')
            .addClass('ml-2 mb-1 close')
        );

        return this;
    }

    setBodyContent($element){
        this.$body
        .html('')
        .append($element);

        return this;
    }


    show(){
        this.toast.show();
    }

    onShow(event){
        this.settings.onShow(event);
    }

    hide(){
        this.toast('hide');
    }

    onHide(event){
        this.settings.onHide(event);
    }

    onClick(event){
        this.remove();
    }

    dispose(){
        var self = this;
        this.toast.dispose();

        //delete toast dom after a few ms to cleanup dom
        setTimeout(
            function(){
                self.remove();
            },
            300
        );
    }

    remove(){
        this.$toast.remove();
    }

    render(){
        return this.$container;
    }
}

module.exports = Toast;